import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button } from "react-bootstrap";

const ManageMembership: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-4 pt-5 pt-md-5 m-0">
      <div className="card shadow-lg border-0 p-4">
        <h4 className="fw-semibold mb-4">Manage Membership</h4>
        <div className="d-flex flex-column flex-md-row gap-3">
          <Card className="flex-fill border shadow-sm">
            <Card.Body>
              <Card.Title>Upgrade membership</Card.Title>
              <Card.Text className="text-muted">
                Change your plan or renew your membership.
              </Card.Text>
              <Button
                variant="primary"
                onClick={() => navigate("/renew-membership")}
              >
                Upgrade / Renew
              </Button>
            </Card.Body>
          </Card>
          <Card className="flex-fill border shadow-sm">
            <Card.Body>
              <Card.Title>Cancel Membership</Card.Title>
              <Card.Text className="text-muted">
                Request to cancel your SMBF membership.
              </Card.Text>
              <Button
                variant="outline-danger"
                onClick={() => navigate("/cancel-membership")}
              >
                Cancel Membership
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ManageMembership;
